import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	name: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.name.no-translate',
		defaultMessage: 'Name',
		description: 'Label of name input',
	},
	namePlaceholder: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.name-placeholder.no-translate',
		defaultMessage: 'Enter a name for the policy',
		description: 'Placeholder of name input',
	},
	description: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.description.no-translate',
		defaultMessage: 'Description',
		description: 'Label of description input',
	},
	descriptionPlaceholder: {
		id: 'eoc.escalation-policies.ui.escalation-policy-modal.description-placeholder.no-translate',
		defaultMessage: 'Enter a description',
		description: 'Placeholder of description input',
	},
});

export default messages;
